import apiClient, { ApiResponse } from './client';

interface CloudCallbackResponse {
  url: string | null;
  error?: string;
}

/**
 * Tells the API that an embedded seller published a design. The API checks
 * that the design is theirs and makes the signed call to the shop's cloud;
 * the browser only ever sends its own JWT. Resolves to the cloud's redirect
 * URL, or null when there is none — the caller then stays in DesignDeck.
 */
export async function requestCloudCallback(
  designId: string,
  channelName?: string
): Promise<string | null> {
  try {
    // Product creation on the cloud side can take ~60 s; the API waits up to
    // 120 s for it. The client budget has to cover that plus the ownership
    // lookup and the round trip, or a slow cloud answer arrives at a browser
    // that has already given up.
    const response = await apiClient.get<ApiResponse<CloudCallbackResponse>>(
      '/designs/cloud-callback',
      { params: { designId, channelName }, timeout: 140_000 }
    );
    const data = response.data.data;
    if (!data || (typeof data.error === 'string' && data.error.length > 0)) {
      return null;
    }
    const url = data.url;
    return typeof url === 'string' && url.length > 0 ? url : null;
  } catch (err: unknown) {
    console.error('[cloudCallback] Request failed', err);
    return null;
  }
}
